(function () {
  'use strict';

  function initHomepageHero(hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.slide'));
    if (!slides.length) return;

    var prev = hero.querySelector('.btn-prev');
    var next = hero.querySelector('.btn-next');
    var current = Math.max(0, slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    }));
    var timer = null;
    var interval = 8000;
    var touchStartX = null;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      current = index;
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (slides.length > 1) {
        timer = window.setInterval(function () {
          show(current + 1);
        }, interval);
      }
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        show(current - 1);
        start();
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        show(current + 1);
        start();
      });
    }

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    hero.addEventListener('touchstart', function (event) {
      if (event.touches && event.touches.length === 1) {
        touchStartX = event.touches[0].clientX;
      }
    }, { passive: true });

    hero.addEventListener('touchend', function (event) {
      if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;

      if (Math.abs(deltaX) > 40) {
        show(deltaX < 0 ? current + 1 : current - 1);
        start();
      }
    }, { passive: true });

    show(current);
    start();
  }

  function init() {
    var heroes = document.querySelectorAll('[data-homepage-hero]');
    Array.prototype.forEach.call(heroes, initHomepageHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
